var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7903_98957)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.714844,
    width: 23.715,
    height: 23.715,
    rx: 4.08879,
    fill: "#E02F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1852 6.80198C24.1852 6.80198 23.954 5.05819 23.2433 4.29042C22.3414 3.28402 21.3313 3.27809 20.8681 3.22103C17.5502 2.96387 12.5738 2.96387 12.5738 2.96387H12.5627C12.5627 2.96387 7.58625 2.96387 4.26912 3.22103C3.80594 3.27809 2.79657 3.28402 1.89392 4.29042C1.18396 5.05819 0.951993 6.80198 0.951993 6.80198C0.951993 6.80198 0.714844 8.84814 0.714844 10.8943V12.8122C0.714844 14.8599 0.951993 16.9053 0.951993 16.9053C0.951993 16.9053 1.18321 18.6483 1.89392 19.4146C2.79657 20.421 3.9801 20.3907 4.50775 20.4959C6.40421 20.6901 12.5686 20.7501 12.5686 20.7501C12.5686 20.7501 17.5502 20.7412 20.8681 20.487C21.3313 20.4277 22.3414 20.4218 23.2433 19.4154C23.9533 18.6491 24.1852 16.906 24.1852 16.906C24.1852 16.906 24.4224 14.8599 24.4224 12.813V10.895C24.4224 8.84814 24.1852 6.80198 24.1852 6.80198Z",
    fill: "#E02F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60742 7.41016V16.3033L17.0183 11.8567L9.60742 7.41016Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7903_98957"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.714844,
    width: 23.715,
    height: 23.715,
    rx: 4.08879,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6449c273052e0a8fa94681676b5c0e94.svg";
export { ForwardRef as ReactComponent };